<template>
  <v-checkbox
    v-bind="$attrs"
    :color="computedColor"
    class="ds-checkbox"
  >
    <template v-for="(_, slot) in $slots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope || {}" />
    </template>
  </v-checkbox>
</template>

<script setup lang="ts">
import { computed } from 'vue'

export interface DsCheckboxProps {
  /**
   * Color del checkbox según el sistema de diseño
   * @default 'primary'
   */
  dsColor?: 'primary' | 'accent' | 'success' | 'error' | 'warning' | 'info'
}

const props = withDefaults(defineProps<DsCheckboxProps>(), {
  dsColor: 'primary'
})

const computedColor = computed(() => {
  switch (props.dsColor) {
    case 'accent':
      return 'accent'
    case 'success':
      return 'success'
    case 'error':
      return 'error'
    case 'warning':
      return 'warning'
    case 'info':
      return 'info'
    default:
      return 'primary'
  }
})
</script>

<style scoped lang="scss">
.ds-checkbox {
  // Los estilos base están definidos en los defaults de Vuetify
}
</style>
